import React from "react"
import Border from "./Border"
import Collapsible from "react-collapsible"
import Toggle from "./sectioninputs/Toggle"
import Dropdown from "./Dropdown"

const OPTIONS = [
  {
    value: "square",
    label: "Square Swatches"
  },
  {
    value: "circular",
    label: "Circular Swatches"
  }
]

const COLOR_SWATCH_TRIGGERS = "Color Swatches"
const COLOR_SWATCH_TITLE = "Display Color Swatch"
const COLOR_SWATCH_PLACEHOLDER = "Select An Option"
const COLOR_SWATCH_DROPDOWN_LABEL = "Color Swatch Style"

const ProductCardColorSwatchSettings = ({ data, update }) => {
    const swatchStyleValue = data?.extra?.product_tile_color_swatch || OPTIONS[0].value
    return (
        <>
            <Border>
              <Collapsible
                trigger={COLOR_SWATCH_TRIGGERS}
              >
                <br/>
                <Toggle
                  id="toggle_product_card_tile_swatch"
                  checked={data?.extra?.display_product_tile_color_swatch}
                  title={COLOR_SWATCH_TITLE}
                  onChange={checked => {
                    if (!data.extra) {
                      data.extra = {}
                    }
                    data.extra.display_product_tile_color_swatch = checked
                    update({ data })
                  }}
                />
                <span>{COLOR_SWATCH_DROPDOWN_LABEL}</span>
                <Dropdown
                  options={OPTIONS}
                  value={OPTIONS.find(
                    (mode) => mode.value == swatchStyleValue
                  )}
                  onChange={(option) => {
                    if (!data.extra) {
                      data.extra = {}
                    }
                    data.extra.product_tile_color_swatch = option.value
                    update({ data })
                  }}
                  placeholder={COLOR_SWATCH_PLACEHOLDER}
                />
              </Collapsible>
            </Border>
        </>
    )
}

export default ProductCardColorSwatchSettings
